module.exports = __webpack_public_path__ + "img/record.083f5a78.png";